import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import errorTokens from "@amzn/meridian-tokens/base/icon/error";
import star from "../../images/star.svg";
import { THEME_COLOR } from "../../styles/colors";
import WaveformLayout from "./WaveformLayout";

const RtmsRejected = ({ rtmsRequesterName }) => {
  return (
    <>
      <WaveformLayout icon={<Icon tokens={errorTokens} color="error" />} />
      <Row height="16px"/>
      <Row alignmentHorizontal="center" spacing="none">
        <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.LIGHT_TEAL }}>
          <Box type="outline" width="252px" spacingInset="400">
            <Row spacing="none" alignmentVertical="top">
              <img src={star} alt="star" />
              <Column width="8px" />
              <Column spacing="none">
                <Text type="h50" alignment="start">
                  {rtmsRequesterName}
                </Text>
                <Text type="b200" alignment="start">
                  is starting summary...
                </Text>
              </Column>
            </Row>
          </Box>
        </Theme>
      </Row>
    </>
  );
};

export default RtmsRejected;
